import axios from "axios";
import { get } from "lodash-es";

const actions = {
  async listPolicy(context, payload) {
    try {
      const response = await this.$api.call("logistic.listPolicy", payload);
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationPolicies", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationPolicies", responseData);
      }

      context.commit("mutationPoliciesMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationPoliciesMeta", {});
      context.commit("mutationPolicies", []);
      throw error;
    }
  },

  async detailPolicy(context, payload) {
    try {
      const response = await this.$api.call("logistic.detailPolicy", payload);
      const responseData = response.data;

      context.commit("mutationPolicy", responseData);

      return response;
    } catch (error) {
      context.commit("mutationPolicy", {});
      throw error;
    }
  },

  async listClaim(context, payload) {
    try {
      const response = await this.$api.call("logistic.listClaim", payload);
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationClaims", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationClaims", responseData);
      }

      context.commit("mutationClaimsMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationClaimsMeta", {});
      context.commit("mutationClaims", []);
      throw error;
    }
  },

  async detailClaim(context, payload) {
    try {
      const response = await this.$api.call("logistic.detailClaim", payload);
      const responseData = response.data;

      context.commit("mutationClaim", responseData);

      return response;
    } catch (error) {
      context.commit("mutationClaim", {});
      throw error;
    }
  },

  async listClaimsHistoriesClaim(context, payload) {
    try {
      const response = await this.$api.call(
        "logistic.claimsHistoriesClaim",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationListClaimsHistoriesClaim", responseData);

      return response;
    } catch (error) {
      context.commit("mutationListClaimsHistoriesClaim", {});
      throw error;
    }
  },

  async listPartners(context, payload) {
    try {
      const response = await this.$api.call("logistic.listPartners", payload);
      const responseData = response.data;

      context.commit("mutationPartners", responseData);

      return response;
    } catch (error) {
      context.commit("mutationPartners", []);
      throw error;
    }
  },

  async listProduct(context, payload) {
    try {
      const response = await this.$api.call("logistic.listProduct", payload);
      const responseData = response.data;

      context.commit("mutationProducts", responseData);

      return response;
    } catch (error) {
      context.commit("mutationProducts", {});
      throw error;
    }
  },

  async listProductCategory(context, payload) {
    try {
      const response = await this.$api.call(
        "logistic.listProductCategory",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationProductCategories", responseData);

      return response;
    } catch (error) {
      context.commit("mutationProductCategories", {});
      throw error;
    }
  },

  async downloadAllPolicy(_context, payload) {
    try {
      const response = await this.$api.call(
        "logistic.downloadAllPolicy",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async downloadAllClaim(_context, payload) {
    try {
      const response = await this.$api.call(
        "logistic.downloadAllClaim",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async getPresign(_context, payload) {
    try {
      const response = await this.$api.call("logistic.getPresign", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async getPresignPolicy(_context, payload) {
    try {
      const response = await this.$api.call(
        "logistic.getPresignPolicy",
        payload,
      );
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async getPresignClaim(_context, payload) {
    try {
      const response = await this.$api.call(
        "logistic.getPresignClaim",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async hitPresignUrl(context, { buffer, url }) {
    try {
      const response = await axios.put(url, buffer, {
        onUploadProgress: (progressEvent) => {
          const progress = (progressEvent.loaded / progressEvent.total) * 100;
          context.commit(
            "mutationUploadProgress",
            parseInt(Math.round(progress), 10),
          );
        },
      });
      const responseData = response.data;

      // reset uploadProgress to 0 (init state)
      context.commit("mutationUploadProgress", 0);

      return responseData;
    } catch (error) {
      // reset uploadProgress to 0 (init state)
      context.commit("mutationUploadProgress", 0);

      throw error;
    }
  },

  async uploadPolicies(context, payload) {
    try {
      const response = await this.$api.call("logistic.uploadPolicies", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async processPolicyToClaim(_context, payload) {
    try {
      const response = await this.$api.call(
        "logistic.processPolicyToClaim",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async updateClaim(_context, payload) {
    try {
      const response = await this.$api.call("logistic.updateClaim", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async sharePolicy(_context, payload) {
    try {
      const response = await this.$api.call("logistic.sharePolicy", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async resendPaymentLink(_context, payload) {
    try {
      const response = await this.$api.call(
        "logistic.resendPaymentLink",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  setCreatePolicy(context, payload) {
    context.commit("mutationCreatePolicy", payload);
  },

  async listProductService(context, payload) {
    try {
      // const response = await this.$api.call(endpoint, payload);
      const response = await this.$api.call("logistic.listProduct", payload);
      const responseData = response.data;
      const responseMeta = response.meta;

      context.commit("mutationProductService", responseData);
      context.commit(
        "mutationProductServiceBuybackProgram",
        responseMeta.withBuyBackProgram,
      );

      return response;
    } catch (error) {
      context.commit("mutationProductService", {});
      throw error;
    }
  },

  async setListProductService(context, payload) {
    context.commit("mutationProductService", payload);
  },

  async listBrand(context, payload) {
    try {
      const response = await this.$api.call("logistic.listBrand", payload);
      const responseData = response.data;

      context.commit("mutationListBrand", responseData);

      return response;
    } catch (error) {
      context.commit("mutationListBrand", {});
      throw error;
    }
  },
  async listType(context, payload) {
    try {
      const response = await this.$api.call("logistic.listType", payload);
      const responseData = response.data;

      context.commit("mutationListType", responseData);

      return response;
    } catch (error) {
      context.commit("mutationListType", {});
      throw error;
    }
  },

  async addPolicy(_context, payload) {
    try {
      const response = await this.$api.call("logistic.addPolicy", payload);

      return response;
    } catch (error) {
      throw error;
    }
  },

  async checkingImei(context, payload) {
    try {
      const response = await this.$api.call("logistic.checkingImei", {
        params: payload.params,
      });
      const { data } = payload;

      if (!response.data.error) {
        data.brand = get(response.data, "brand", null);
        data.type = get(response.data, "model", null);
        data.imeiIsValid = true;

        context.commit("mutationCreateClaim", payload.data);

        return null;
      }

      data.imeiIsValid = false;
      data.brand = "";
      data.type = "";

      context.commit("mutationCreateClaim", payload.data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  setCreateClaim(context, payload) {
    context.commit("mutationCreateClaim", payload);
  },

  setIsValidCreateClaim(context, payload) {
    context.commit("mutationIsValidCreateClaim", payload);
  },

  setListBrand(context, payload) {
    context.commit("mutationListBrand", payload);
  },

  async searchClaim(_context, payload) {
    try {
      const response = await this.$api.call("logistic.searchClaim", payload);

      return response;
    } catch (error) {
      throw error;
    }
  },

  async addClaim(_context, payload) {
    try {
      const response = await this.$api.call("logistic.addClaim", payload);

      return response;
    } catch (error) {
      throw error;
    }
  },

  async addCostEstimation(_context, payload) {
    try {
      const response = await this.$api.call(
        "logistic.addCostEstimation",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async fetchQuestionCostEstimation(context, payload) {
    try {
      const response = await this.$api.call(
        "logistic.fetchQuestionCostEstimation",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationQuestionCostEstimation", responseData);

      return response;
    } catch (error) {
      throw error;
    }
  },
  async uploadFilesCostEstimation(context, payload) {
    try {
      const response = await this.$api.call(
        "logistic.uploadFilesCostEstimation",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationFilesCostEstimation", responseData);

      return response;
    } catch (error) {
      throw error;
    }
  },

  async extractImei(context, payload) {
    try {
      const response = await this.$api.call("logistic.extractImei", {
        data: payload.data,
      });

      // const { form } = payload;
      if (response.data.imei.length === 0) {
        // const [imei0] = response.data.imei;
        // form.imei = imei0;
        // form.imeiIsValid = false;
        throw new Error("Imei is not found! Please check again.");
      }

      const data = {
        ...payload.form,
        imeiIsValid: true,
      };

      context.commit("mutationCreateClaim", data);
      context.commit("mutationExtractImei", response.data);

      return response;
    } catch (error) {
      throw error;
    }
  },

  async urlTemplateUpload(context, payload) {
    try {
      const response = await this.$api.call(
        "logistic.urlTemplateUpload",
        payload,
      );

      context.commit("mutationGetTemplateUrl", response.data);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default actions;
